import { Navigate } from 'react-router-dom'

import { FeatureFlagAvailabilitiesDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

const RedirectPage = () => {
  const { company } = useCurrentSession()

  const { data, loading } = useQuery(FeatureFlagAvailabilitiesDocument, {
    fetchPolicy: 'cache-and-network',
    variables: {
      companyId: company.id,
      featureNames: ['enable_new_inbox'],
    },
  })

  const newInboxEnabled = data?.features?.featuresConnection?.nodes?.some((node) => node.enabled)

  const { navigation } = useNavigation()

  if (!data && loading) {
    return <Loading />
  }

  const path = newInboxEnabled
    ? navigation.inbox.todo.fullPath()
    : navigation.inbox.requests.fullPath()

  return <Navigate replace to={path} />
}

export default RedirectPage
